export interface Session {
  id: string;
  startDate: string;
  endDate: string;
  capacity: number;
  sessionId: string;
  disabled: boolean;
}

export interface AvailableDay {
  id: string;
  date: string;
  totalCapacity: number;
  disabled: boolean;
  sessions: Session[];
}

export interface Schedule {
  monthName: string;
  year: number;
  disabled: boolean;
  availableDays: AvailableDay[];
}

export interface ScheduleData {
  schedules: Schedule[];
}

export interface CategorizedSessions {
  morning: Session[];
  afternoon: Session[];
  evening: Session[];
}

export interface TimeFrameItem {
  id: string;
  capacity: number;
  startTime: string;
  endTime: string;
  sessionId?: string;
}

export interface TabLabel {
  label: string;
  iconName: string;
}

// Constants
export const TIME_PERIODS = {
  MORNING: { start: 0, end: 12 },
  AFTERNOON: { start: 12, end: 18 },
  EVENING: { start: 18, end: 24 }
} as const;

export const TAB_INDICES = {
  MORNING: 0,
  AFTERNOON: 1,
  EVENING: 2
} as const;

export const MESSAGES = {
  NO_MORNING_SESSIONS: 'در بازه صبح هیچ نوبت خالی وجود ندارد!',
  NO_AFTERNOON_SESSIONS: 'در بازه ظهر هیچ نوبت خالی وجود ندارد!',
  NO_EVENING_SESSIONS: 'در بازه عصر و شب هیچ نوبت خالی وجود ندارد!',
  PREVIOUS_MONTH: 'ماه قبل',
  NEXT_MONTH: 'ماه بعد',
  SELECT_TIME_TITLE: 'انتخاب زمان مشاوره',
  Lower_than_the_tariff: 'پایین تر از تعرفه'
} as const;

export const TAB_LABELS: TabLabel[] = [
  { label: 'صبح', iconName: 'morning' },
  { label: 'ظهر', iconName: 'afternoon' },
  { label: 'عصر و شب', iconName: 'evening' }
];
